import * as ambassadorWixSocialGroupsV2GroupRequest from './social-groups-v2-group-request-group-requests.http.js';
import * as ambassadorWixSocialGroupsV2GroupRequestTypes from './social-groups-v2-group-request-group-requests.types.js';
import * as ambassadorWixSocialGroupsV2GroupRequestUniversalTypes from './social-groups-v2-group-request-group-requests.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function approveGroupRequests(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.ApproveGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestTypes.ApproveGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.ApproveGroupRequestsResponse,
  ambassadorWixSocialGroupsV2GroupRequestTypes.ApproveGroupRequestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupRequest.approveGroupRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/group-requests/approve',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function rejectGroupRequests(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.RejectGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestTypes.RejectGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.RejectGroupRequestsResponse,
  ambassadorWixSocialGroupsV2GroupRequestTypes.RejectGroupRequestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupRequest.rejectGroupRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/group-requests/reject',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listGroupRequests(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.ListGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestTypes.ListGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.ListGroupRequestsResponse,
  ambassadorWixSocialGroupsV2GroupRequestTypes.ListGroupRequestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupRequest.listGroupRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/group-requests',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryGroupRequests(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.QueryGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestTypes.QueryGroupRequestsRequest,
  ambassadorWixSocialGroupsV2GroupRequestUniversalTypes.QueryGroupRequestsResponse,
  ambassadorWixSocialGroupsV2GroupRequestTypes.QueryGroupRequestsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupRequest.queryGroupRequests(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/group-requests/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  GroupRequest as GroupRequestOriginal,
  Group as GroupOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Events as EventsOriginal,
  Logo as LogoOriginal,
  GroupDetailsPosition as GroupDetailsPositionOriginal,
  Image as ImageOriginal,
  Position as PositionOriginal,
  AllowPolicy as AllowPolicyOriginal,
  AllowPolicyWithLiterals as AllowPolicyWithLiteralsOriginal,
  OnboardingStepSettings as OnboardingStepSettingsOriginal,
  StepKey as StepKeyOriginal,
  StepKeyWithLiterals as StepKeyWithLiteralsOriginal,
  PrivacyStatus as PrivacyStatusOriginal,
  PrivacyStatusWithLiterals as PrivacyStatusWithLiteralsOriginal,
  AccessRestriction as AccessRestrictionOriginal,
  AccessRestrictionDataOneOf as AccessRestrictionDataOneOfOriginal,
  GroupDetails as GroupDetailsOriginal,
  CoverImage as CoverImageOriginal,
  GroupSettings as GroupSettingsOriginal,
  Identity as IdentityOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  RequestStatus as RequestStatusOriginal,
  RequestStatusWithLiterals as RequestStatusWithLiteralsOriginal,
  RequestDetails as RequestDetailsOriginal,
  SubmitGroupRequestRequest as SubmitGroupRequestRequestOriginal,
  ContentType as ContentTypeOriginal,
  ContentTypeWithLiterals as ContentTypeWithLiteralsOriginal,
  SubmitGroupRequestResponse as SubmitGroupRequestResponseOriginal,
  ApproveGroupRequestsRequest as ApproveGroupRequestsRequestOriginal,
  ItemsToUpdate as ItemsToUpdateOriginal,
  ItemsToUpdateWithLiterals as ItemsToUpdateWithLiteralsOriginal,
  ApproveGroupRequestsResponse as ApproveGroupRequestsResponseOriginal,
  GroupRequestApproved as GroupRequestApprovedOriginal,
  RejectGroupRequestsRequest as RejectGroupRequestsRequestOriginal,
  Rejection as RejectionOriginal,
  RejectGroupRequestsResponse as RejectGroupRequestsResponseOriginal,
  GroupRequestRejected as GroupRequestRejectedOriginal,
  CancelGroupRequestRequest as CancelGroupRequestRequestOriginal,
  CancelGroupRequestResponse as CancelGroupRequestResponseOriginal,
  ListGroupRequestsRequest as ListGroupRequestsRequestOriginal,
  OwnershipFilter as OwnershipFilterOriginal,
  OwnershipFilterWithLiterals as OwnershipFilterWithLiteralsOriginal,
  ListGroupRequestsResponse as ListGroupRequestsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  QueryGroupRequestsRequest as QueryGroupRequestsRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryGroupRequestsResponse as QueryGroupRequestsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './social-groups-v2-group-request-group-requests.types.js';
